import { useMemo } from 'react'
import { StringParam, useQueryParams } from 'use-query-params'

export type UseActiveTabProps = {
  tabValues: string[]
}

export const useActiveTab = ({ tabValues }: UseActiveTabProps) => {
  const [queryParams, setQueryParams] = useQueryParams({
    tab: StringParam,
  })

  const setTabParam = (tab?: string) => setQueryParams({ tab })

  const activeTab = useMemo(() => {
    return tabValues.includes(queryParams.tab ?? '') ? (queryParams.tab as string) : tabValues[0]
  }, [queryParams, tabValues])

  return {
    activeTab,
    setTabParam,
  }
}
